export default {
  name: 'work',
  path: 'work',
  component: () => import('@/views/container/Redirect.vue'),
  meta: {
    title: '特殊作业管理',
    redirect: true,
    hideSubMenu: true,
    icon: 'icon-a-jianqu20'
  },
  children: [
    {
      path: 'integrated-board',
      name: 'integrated-board',
      component: () => import('@/views/work/integrated-board/IntegratedBoard.vue'),
      meta: {
        title: '综合看板'
      }
    },
    {
      path: 'comprehensive-billboard',
      name: 'comprehensive-billboard',
      component: () => import('@/views/work/comprehensive-billboard/ComprehensiveBillboard.vue'),
      meta: {
        title: '作业许可与作业过程管理',
        icon: 'icon-ditu'
      }
    },
    {
      name: 'reservation',
      path: 'reservation',
      component: () => import('@/views/work/reservation/appoint/Appoint.vue'),
      meta: {
        title: '作业预约管理',
        // redirect: true,
        menuChildren: true,
        icon: 'icon-yuyue'
      }
      // children: [
      //   {
      //     name: 'appoint',
      //     path: '',
      //     component: () => import('@/views/work/reservation/appoint/Appoint.vue'),
      //     meta: { title: '作业预约' }
      //   },
      // ]
    },
    {
      name: 'work-process',
      path: 'process',
      component: () => import('@/views/container/Redirect.vue'),
      meta: {
        title: '作业过程管理',
        redirect: true,
        menuChildren: true
      },
      children: [
        {
          name: 'work-process-list',
          path: '',
          component: () => import('@/views/work/process/list/List.vue'),
          meta: { title: '作业过程列表' }
        }, {
          name: 'work-process-detail',
          path: 'detail',
          component: () => import('@/views/work/process/detail/Detail.vue'),
          meta: { title: '作业过程详情' }
        }
      ]
    },
    {
      name: 'work-history',
      path: 'history',
      component: () => import('@/views/container/Redirect.vue'),
      meta: {
        title: '历史作业票管理',
        redirect: true,
        menuChildren: true,
        icon: 'icon-lishizuoye'
      },
      children: [
        {
          name: 'work-history-list',
          path: '',
          component: () => import('@/views/work/history/list/List.vue'),
          meta: { title: '历史作业列表' }
        }, {
          name: 'work-history-detail',
          path: 'detail',
          component: () => import('@/views/work/history/detail/Detail.vue'),
          meta: { title: '历史作业详情' }
        }
      ]
    },
    {
      name: 'work-abandon',
      path: 'abandon',
      component: () => import('@/views/container/Redirect.vue'),
      meta: {
        title: '废票管理',
        redirect: true,
        menuChildren: true,
        icon: 'icon-lishizuoye'
      },
      children: [
        {
          name: 'work-abandon-list',
          path: '',
          component: () => import('@/views/work/abandon/list/List.vue'),
          meta: { title: '废票列表' }
        }, {
          name: 'work-abandon-detail',
          path: 'detail',
          component: () => import('@/views/work/abandon/detail/Detail.vue'),
          meta: { title: '废票详情' }
        }
      ]
    },
    {
      name: 'work-config',
      path: 'config',
      component: () => import('@/views/container/Redirect.vue'),
      meta: {
        title: '作业配置',
        redirect: true,
        icon: 'icon-shezhi'
      },
      children: [
        {
          name: 'gas-reservoir',
          path: 'gas-reservoir',
          component: () => import('@/views/work/config/gas-reservoir/GasReservoir.vue'),
          meta: { title: '气体库设置' }
        }, {
          name: 'ticket',
          path: 'ticket',
          component: () => import('@/views/work/config/ticket/Ticket.vue'),
          meta: { title: '作业票设置' }
        }, {
          name: 'work-region',
          path: 'region',
          component: () => import('@/views/container/Redirect.vue'),
          meta: {
            title: '作业地点设置',
            redirect: true,
            menuChildren: true
          },
          children: [
            {
              name: 'work-region-list',
              path: 'list',
              component: () => import('@/views/work/config/region/list/List.vue'),
              meta: { title: '列表' }
            }, {
              name: 'work-region-add',
              path: 'add',
              component: () => import('@/views/work/config/region/add/Add.vue'),
              meta: { title: '新增' }
            }
          ]
        }, {
          name: 'parameter-setting',
          path: 'parameter-setting',
          component: () => import('@/views/work/config/parameter-setting/ParameterSetting.vue'),
          meta: { title: '参数设置' }
        }
      ]
    }
  ]
}
